var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WelcomeView"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pa-0"},[_c('SliderBannerComponent',{attrs:{"images":_vm.bannerImages,"height":"40vh"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }